// Atención humana por proyecto (script 52): modo y roles. La regla del reparto vive en la base de datos (private.attention_assign);
// aquí solo se arma lo que se muestra.

export const MODES = {
  classic: {
    label: 'Clásico',
    help: 'Como hoy: al pasar un chat a una persona se avisa a todo el equipo y nadie queda como responsable.',
  },
  assigned: {
    label: 'Con asignación',
    help: 'Cada chat que pasa a una persona tiene un responsable: el usuario de nivel 2 con menos chats abiertos; si no hay, un administrador del proyecto.',
  },
};

export const ROLES = {
  project_admin: { label: 'Administrador del proyecto', help: 'Ve todos los chats y puede reasignarlos.' },
  attendant: { label: 'Atención (nivel 2)', help: 'En Chats solo ve los chats que se le asignan.' },
};

/** Avisos para el admin según el modo y el equipo (lista de attention_team). */
export function teamWarnings(mode, team) {
  if (!team.length) return ['Este proyecto no tiene usuarios. Dalos de alta en Clientes y asígnales este proyecto.'];
  if (mode !== 'assigned') return [];
  const out = [];
  const active = team.filter((m) => m.is_active);
  if (!active.some((m) => m.role === 'attendant')) out.push('No hay usuarios de nivel 2 en el reparto: todos los chats irán a los administradores del proyecto.');
  if (!active.some((m) => m.role === 'project_admin')) out.push('No hay administradores del proyecto en el reparto: si nadie de nivel 2 está disponible, el chat se queda sin responsable.');
  return out;
}
